export default class GetPresignedUrlError extends Error {
  constructor(public message: string) {
      super(message);
      Error.captureStackTrace(this, GetPresignedUrlError);
  }
}
